<template>
  <div>
    <div class="slideshow-container" :id="'slideshow-container-'+_uid" >
        <div v-for="slide in slides" :key="slide.id" v-bind:id="'slide_'+slide.id+'-'+_uid" class="hidden_slide fade"  v-on:click="gotoItem(slide.itemid)" v-bind:class="{'pointer_cursor':((slide.itemid!=false || type=='item') && in_transition==false)}">
            <img v-bind:src="slide.src"  v-bind:class="{'center-fit':true, fluid:fluid}" class="ui image">
            <div v-if="type=='home' || type=='modal'" class="text" v-bind:class="{over:type=='home' && !slide.invert,invert_over:type=='home' && slide.invert}">{{slide.title}}</div>
        </div>
        <i v-if="slides.length>1 && type!='item'" class="large chevron left icon control_arrows prev" v-bind:class="{inverted:type=='home'}"  v-on:click="prevSlide()"></i>
        <i v-if="slides.length>1 && type!='item'" class="large chevron right icon control_arrows next" v-bind:class="{inverted:type=='home'}" v-on:click="nextSlide()"></i>
    </div>
    <div v-if="slides.length>1" style="text-align:center;padding:10px;" >
        <span v-for="slide in slides" :key="slide.id" class="dot" v-on:click="showSlide(slide.id)" v-bind:class="{'active_dot':slide.id==currentSlide}"></span>
    </div>
   <TheSimpleModal v-if="type!='modal' && modalIsOpen" @closeMe="modalIsOpen=false">
     <TheCarousel type="modal" v-bind:slides="slides" ></TheCarousel>
   </TheSimpleModal>
</div>
</template>

<script>
import TheSimpleModal from './TheSimpleModal.vue'
  export default {
    name: 'TheCarousel',
    props: ['slides', 'type', 'fluid', 'auto', 'fx'],
    data() {
      return {
        currentSlide: 0,
        lastSlide: 0,
        interval: null,
        in_transition: false,
        modalIsOpen:false

      }
    },
    mounted() {

      this.showSlide(0);

      if (this.auto) {
        var localThis = this;
        this.interval = setInterval(function() {
          localThis.nextSlide();
        }, 5000);

      }
    },

    beforeDestroy() {

      if (this.auto) {
        clearInterval(this.interval);
      }
    },

    methods: {
      gotoItem: function(id) {
        if (!this.in_transition) {
          if (id) {
            this.$router.push({ path: '/item/' + id });
          }
          if (this.type == 'item') {
            //this.$emit('openModal');
            this.modalIsOpen=true;
          }
        }
      },


      nextSlide: function() {
        if ((this.currentSlide + 1) == this.slides.length) {
          this.showSlide(0)
        }
        else {
          this.showSlide(this.currentSlide + 1);
        }
      },

      prevSlide: function() {
        if (this.currentSlide == 0) {
          this.showSlide(this.slides.length - 1)
        }
        else {
          this.showSlide(this.currentSlide - 1);
        }
      },

      showSlide: function(slide_id) {
        this.currentSlide = slide_id
        var localThis = this;
        if (this.fx && this.lastSlide != this.currentSlide) {
          $('#slideshow-container-' + localThis._uid).css('background-image', 'url(' + localThis.slides[localThis.currentSlide].src + ')')
          $('#slide_' + localThis.lastSlide + '-' + localThis._uid).bind('transitionend', function() {
            $('#slide_' + localThis.lastSlide + '-' + localThis._uid).css('display', 'none');
            $('#slide_' + localThis.currentSlide + '-' + localThis._uid).css('display', 'grid');
            $('#slide_' + localThis.lastSlide + '-' + localThis._uid).css('opacity', '1');
            localThis.lastSlide = localThis.currentSlide;
            localThis.in_transition = false;
          });
          localThis.in_transition = true;
          $('#slide_' + localThis.lastSlide + '-' + localThis._uid).css('opacity', '0')
        }
        else {
          $('#slide_' + localThis.lastSlide + '-' + localThis._uid).css('display', 'none')
          $('#slide_' + localThis.currentSlide + '-' + localThis._uid).css('display', 'grid')
          localThis.lastSlide = localThis.currentSlide;
        }
      },

    },
     components: {
           
            TheSimpleModal,
           
        },
  }
</script>

<style scoped>
  .slideshow-container {
    position: relative;
    margin: auto;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .center-fit {
    max-width: 100%;
    max-height: 80vh;
    margin: auto;
  }

  .topimage {
    display: grid!important;
    opacity: 0;
  }

  .hidden_slide {
    display: none;

  }

  .control_arrows {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
  }

  .control_arrows:hover {
    color: #000000;
    background-color: rgba(255, 255, 255, 0.3);
  }

  .prev {
    left: 0px;
  }

  .next {
    right: 0px;
  }

  .text {
    color: #000000;
    font-size: 15px;
    width: 100%;
    padding: 15px;
    text-align: center;
  }

  .over {
    position: absolute;
    bottom: 0px;
    background-color: rgba(255, 255, 255, 0.6);
  }

  .invert_over {
    position: absolute;
    bottom: 0px;
    color: #FFFFFF;
    background-color: rgba(0, 0, 0, 0.6);
  }



  .dot {
    cursor: pointer;
    height: 10px;
    width: 10px;
    margin: 0 2px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    transition: background-color 0.6s ease;
  }

  .active_dot,
  .dot:hover {
    background-color: #717171;
  }

  .pointer_cursor {
    cursor: pointer;
  }

  .fade {
    transition: opacity 2s
  }
</style>



// WEBPACK FOOTER //
// src/components/TheCarousel.vue